import { create } from 'zustand';

import type { ScrollPosition, TabElement } from '@/types/auditTabs';

interface RouterState {
  tabs: TabElement[];
  scrollTo: string;
  selectedTabId: string;
  selectedTabIndex: number;
  selectedTabCards: Record<string, string>;
  scrollPositions: ScrollPosition[];
  submitAuditModalCaseUuid: string | null;
  setSubmitAuditModalCaseUuid: (submitAuditModalCaseUuid: string | null) => void;
  setTabs: (tabs: TabElement[]) => void;
  setSelectedTabCard: (tabId: string, tabValue: string) => void;
  setSelectedTabId: (tabId: string) => void;
  saveScrollPosition: (scrollPosition: ScrollPosition) => void;
  resetScrollTo: () => void;
  scrollToElement: (
    scrollElementId: string,
    mainTabId: string,
    cardId: string,
    tabCardTabValue?: string,
  ) => void;
  resetRouter: () => void;
}

export const useRouterStore = create<RouterState>((set) => ({
  tabs: [],
  scrollTo: '',
  selectedTabId: '',
  selectedTabIndex: 0,
  selectedTabCards: {},
  scrollPositions: [],
  submitAuditModalCaseUuid: null,
  setSubmitAuditModalCaseUuid: (submitAuditModalCaseUuid) => {
    set(() => ({
      submitAuditModalCaseUuid,
    }));
  },
  resetScrollTo: () => {
    set(() => ({
      scrollTo: '',
    }));
  },
  setTabs: (tabs) => {
    set(() => ({
      tabs,
      selectedTabId: tabs[0].id,
      selectedTabIndex: 0,
    }));
  },
  setSelectedTabCard: (tabId, tabValue) => {
    set((prev) => ({
      selectedTabCards: {
        ...prev.selectedTabCards,
        [tabId]: tabValue,
      },
    }));
  },
  setSelectedTabId: (tabId) => {
    set((prev) => ({
      selectedTabId: tabId,
      selectedTabIndex: prev.tabs.findIndex((tab) => tab.id === tabId),
    }));
  },
  saveScrollPosition: (scrollPosition) => {
    let found = false;
    const scrollPositions = useRouterStore.getState().scrollPositions;

    const updatedScrollPosition = scrollPositions.map((pos) => {
      if (
        pos.mainTabValue === scrollPosition.mainTabValue &&
        pos.subTabValue === scrollPosition.subTabValue
      ) {
        found = true;
        return scrollPosition;
      }

      return pos;
    });

    if (!found) {
      updatedScrollPosition.push(scrollPosition);
    }

    set({ scrollPositions: updatedScrollPosition });
  },
  scrollToElement: (scrollElementId, mainTabId, cardId, tabCardTabValue) => {
    set((prev) => ({
      selectedTabId: mainTabId,
      selectedTabIndex: prev.tabs.findIndex((tab) => tab.id === mainTabId),
      scrollTo: scrollElementId,
      ...(cardId && tabCardTabValue
        ? {
            selectedTabCards: {
              ...prev.selectedTabCards,
              [cardId]: tabCardTabValue,
            },
          }
        : {}),
    }));
  },
  resetRouter: () => {
    set(() => ({
      tabs: [],
      scrollTo: '',
      selectedTabId: '',
      selectedTabIndex: 0,
      selectedTabCards: {},
      scrollPositions: [],
    }));
  },
}));
